import axios from 'axios';
import { getGraphToken } from './getAccessTokenForAgent';

export type UserInfo = {
  id: string;
  displayName: string;
  email: string;
  username: string;
};

const getUsername = (email: string): string => {
  if (!email || email.length <= 0) {
    return '';
  }
  if (email.indexOf('@') < 0) {
    return email;
  }
  return email.split('@')[0];
};

export const getUserInfo = async (): Promise<UserInfo> => {
  const accessToken = await getGraphToken();

  const detailsResponse = await axios.get(
    'https://graph.microsoft.com/v1.0/me',
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );

  if (!detailsResponse.data) {
    throw new Error('User details response is empty');
  }
  if (!detailsResponse.data.id || detailsResponse.data.id === '') {
    throw new Error('User ID not found in response');
  }

  return {
    id: detailsResponse.data.id,
    displayName: detailsResponse.data.displayName,
    email: detailsResponse.data.userPrincipalName,
    username: getUsername(detailsResponse.data.userPrincipalName),
  };
};
